<div tiimeFormTitle>I - Prise de connaissance</div>
<div tiimeFormColumn>
  <app-mission-acceptance-form-row
    label="Le cabinet a-t-il rencontré ou eu un contact en visioconférence avec le client pour prendre connaissance de ses
  besoins et découvrir l'entreprise ?"
    required
    tiimeFormRow
  >
    <mat-button-toggle-group class="control-container" [formControl]="form.controls.clientContacted">
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row
    label="Le cabinet a-t-il effectué des recherches sur internet sur l'entreprise et/ou le(s) dirigeant(s) ? "
    required
    tiimeFormRow
  >
    <mat-button-toggle-group class="control-container" [formControl]="form.controls.companyInvestigation">
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
</div>
<div tiimeFormTitle>II - Analyse des risques du client liés</div>
<div tiimeFormColumn>
  <app-mission-acceptance-form-row label="À l’activité" required tiimeFormRow>
    <ng-container
      [ngTemplateOutlet]="riskLevelControl"
      [ngTemplateOutletContext]="{
        control: form.controls.activityRisk
      }"
    ></ng-container>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row
    label="Aux caractéristiques juridiques (Structure juridique, détenteurs du capital, dirigeants de l'entité…)"
    required
    tiimeFormRow
  >
    <ng-container
      [ngTemplateOutlet]="riskLevelControl"
      [ngTemplateOutletContext]="{
        control: form.controls.legalCharacteristicsRisk
      }"
    ></ng-container>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row
    label="À l’historique fiscal et social du client (Contrôles fiscaux, Urssaf…)"
    required
    tiimeFormRow
  >
    <ng-container
      [ngTemplateOutlet]="riskLevelControl"
      [ngTemplateOutletContext]="{
        control: form.controls.fiscalSocialClientHistoryRisk
      }"
    ></ng-container>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row label="Au système d'information et à l'organisation comptable" required tiimeFormRow>
    <ng-container
      [ngTemplateOutlet]="riskLevelControl"
      [ngTemplateOutletContext]="{
        control: form.controls.accountingOrganizationRisk
      }"
    ></ng-container>
  </app-mission-acceptance-form-row>
</div>
<div tiimeFormTitle>
  III - Analyse des besoins du client
  <span class="title-description">Les informations suivantes ont-elles été collectées ?</span>
</div>
<div tiimeFormColumn>
  <app-mission-acceptance-form-row
    label="La nature des missions confiées au cabinet (établissement des comptes annuels, fiscalité, etc.)"
    required
    tiimeFormRow
  >
    <mat-button-toggle-group class="control-container" [formControl]="form.controls.missionObject">
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row
    label="Les besoins complémentaires spécifiques du client (situation, etc.)"
    required
    tiimeFormRow
  >
    <mat-button-toggle-group class="control-container" [formControl]="form.controls.clientAdditionalNeeds">
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row
    label="Les délais spécifiques à respecter (Demande particulière du client, etc.)"
    required
    tiimeFormRow
  >
    <mat-button-toggle-group class="control-container" [formControl]="form.controls.specificDeadlines">
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
</div>
<div tiimeFormTitle>IV - Analyse de la faisabilité de la mission</div>
<div tiimeFormColumn>
  <app-mission-acceptance-form-row
    label="Le cabinet est-il indépendant vis-à-vis du client (famille, financier, etc.) ?"
    required
    tiimeFormRow
  >
    <mat-button-toggle-group class="control-container" [formControl]="form.controls.independentFromClient">
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row
    label="Le cabinet a-t-il la compétence pour réaliser cette mission ?"
    required
    tiimeFormRow
  >
    <mat-button-toggle-group class="control-container" [formControl]="form.controls.legalStructureCompetentForMission">
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row
    label="Le dossier est-il en adéquation avec les méthodes du cabinet ?"
    required
    tiimeFormRow
  >
    <mat-button-toggle-group
      class="control-container"
      [formControl]="form.controls.companyConsistentWithPartnerMethods"
    >
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
  <app-mission-acceptance-form-row
    label="L'offre commerciale est-elle en adéquation avec la mission proposée ?"
    required
    tiimeFormRow
  >
    <mat-button-toggle-group
      class="control-container"
      [formControl]="form.controls.contractConsistentWithProposedMission"
    >
      <mat-button-toggle [value]="true">Oui</mat-button-toggle>
      <mat-button-toggle [value]="false">Non</mat-button-toggle>
    </mat-button-toggle-group>
  </app-mission-acceptance-form-row>
</div>

<ng-template #riskLevelControl let-control="control">
  <mat-button-toggle-group class="control-container" [formControl]="control">
    @for (riskLevel of riskLevels(); track riskLevel.code) {
      <mat-button-toggle [value]="riskLevel.code">{{ riskLevel.label }}</mat-button-toggle>
    }
  </mat-button-toggle-group>
</ng-template>
